/**
 * The sentinel colours every generated sprite sheet is drawn with.
 *
 * ⚠️  THESE MUST MATCH `scripts/generate-placeholder-sprites.mjs` EXACTLY.
 *
 * Recolouring works by exact RGB match: the engine finds every pixel equal to
 * `skin` and replaces it with the player's chosen tone. A value that is one
 * step off matches nothing, so those pixels silently keep the placeholder
 * colour — a half-recoloured character with no error anywhere to explain it.
 *
 * `palette.test.js` compares this table against `hero.palette.json`, which the
 * generator emits alongside the sheets. Drift fails a build instead of shipping.
 */
export const SPRITE_SLOTS = {
  line: '#1A1420',
  hair: '#4A3728',
  skin: '#E8B88A',
  skinDark: '#C99A6F',
  shirt: '#D6DAE0',
  shirtDark: '#A8ADB8',
  pants: '#3D4A5C',
  pantsDark: '#2B3543',
  shoe: '#2A2320',
};

/**
 * How much darker a shade is than its base.
 *
 * Mirrors SHADE in `server/utils/appearance.js`. Both exist because the server
 * needs it for nothing today but will the moment anything renders a character
 * outside the browser, and the client needs it every frame a new look appears.
 */
const SHADE = 0.8;

const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));

/**
 * A darker version of a colour, for the shaded parts of the sprite — sleeves,
 * the back leg, the mouth.
 *
 * Derived rather than chosen: a player picks one shirt colour, not a shirt
 * colour and its shadow.
 */
export function darken(hex, factor = SHADE) {
  const m = /^#([0-9a-f]{6})$/i.exec(String(hex || '').trim());
  if (!m) return hex;

  const n = parseInt(m[1], 16);
  /* eslint-disable no-bitwise */
  const r = clamp(((n >> 16) & 255) * factor);
  const g = clamp(((n >> 8) & 255) * factor);
  const b = clamp((n & 255) * factor);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
  /* eslint-enable no-bitwise */
}

export default SPRITE_SLOTS;
